import type { CloudGraphBranchEntityAti } from '@atlassian/search-client/common/types';

export const DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI: CloudGraphBranchEntityAti[] = [
	'ati:cloud:graph:branch',
];
